export default __webpack_public_path__ + "static/media/photo--sm--35.b19d5e2d.jpg";